import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserBase } from 'src/app/shared/libraries/user-base';
import { AuthorizationBase } from '../../libraries/authorize-base';
import { AuthService } from "../../../core/auth.service";
import { AlertService } from "../../../core/alert.service";

@Component({
  selector: 'app-action-password',
  templateUrl: './action-password.component.html',
  styleUrls: ['./action-password.component.scss']
})
export class ActionPasswordComponent extends AuthorizationBase implements OnInit {
  public user: UserBase;
  baseUrl: string = '';
  clicked: boolean = false;
  busy: boolean = false;
  password: string;

  constructor(public authService: AuthService, private alert: AlertService, private activeModal: NgbActiveModal) {
    super();
    this.user = new UserBase();
    this.baseUrl = environment.accountAPIRoot;
  }

  ngOnInit() {

  }

  verifyPassword() {

    if (!this.password){
      this.alert.alertError({ text: 'Please input password.'});
      return false;
    }

    this.busy = true;
    this.authService.verifyUserActionByPassword(Number(this.userId()), this.password).subscribe((res: any) => {
      if (res) {
        this.close(true);
      }
    },
    (error: any) => {
      this.busy = false;
      this.password = "";
      this.alert.alertError({ title: 'Error encountered', text: error.error });
    }, () => {
      this.busy = false;
    });
  }

  close(data?: any) {
    this.activeModal.close(data);
  }

}
